var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.661 1a.66.66 0 0 1 .661.663v1.635l1.516-.304a7.63 7.63 0 0 1 4.34.4l.18.07a7.03 7.03 0 0 0 4.328.296 1.055 1.055 0 0 1 1.207.564c.07.144.107.303.107.465v6.51a1.24 1.24 0 0 1-.938 1.204l-.188.046a7.63 7.63 0 0 1-4.695-.319 7.63 7.63 0 0 0-4.34-.4l-1.517.305v7.202a.664.664 0 0 1-.661.663.66.66 0 0 1-.661-.663V1.663A.664.664 0 0 1 4.661 1"
  })));
};
export default SvgFlag;